import { useEffect } from "react";
import { RadialChart } from "../Charts/RadialChart";
import * as S from "./EquipMonitoringCard.style";

interface EquipMonitoringProps {
  title?: string;
  status: boolean;
  cardType?: "gauge" | "number";
  data1?: any;
  data2?: any;
  data3?: any;
  data4?: any;
  displayTime?: string;
}

export const EquipMonitoringCard = ({
  title,
  status,
  cardType,
  displayTime,
  data1,
  data2,
  data3,
  data4,
}: EquipMonitoringProps) => {
  return (
    <S.EquipMonitoringCard status={status} cardType={cardType}>
      {/* 장비 운용현황 타이틀 라인 */}
      <S.EquipCardTitleBox cardType={cardType}>
        {title}

        <S.EquipStatusBox>
          <S.EquipCardTimeBox>
            <span>{status === true ? "운전시간" : "정지시간"}</span>
            {/* 운전/정지시간 */}
            {displayTime}
          </S.EquipCardTimeBox>

          {/* 장비 ON/OFF 여부 표기 */}
          <S.EquipCardStatus status={status}>
            {status === true ? "on" : "off"}
          </S.EquipCardStatus>
        </S.EquipStatusBox>
      </S.EquipCardTitleBox>

      {/* 장비 현황수치 */}
      <S.EquipCardContentBox>
        {/* 게이지 표기 */}
        {
          cardType === "gauge" && (
            <>
              <RadialChart
                status={status}
                color="blue"
                // data={{
                //   minValue: 0,
                //   maxValue: 4600,
                //   value: 3400,
                //   unit: "Speed(rpm)",
                // }}
                data={{ ...data1, unit: "Speed(rpm)" }}
              />
              <RadialChart
                status={status}
                color="green"
                data={{ ...data2, unit: "Torque(kNm)" }}
                // data={{
                //   minValue: 0,
                //   maxValue: 150,
                //   value: 120,
                //   unit: "Torque(kNm)",
                // }}
              />
            </>
          )
          // data.map((item: any, idx: number) => {
          //   return (
          //     <S.EquipCardContent>
          //       80
          //       <span>Load(%)</span>
          //     </S.EquipCardContent>
          //   );
          // })
        }

        {/* 수치 표기 */}
        {cardType === "number" && (
          // data.map((item: any, idx: number) => {
          //   return (
          //     <S.EquipCardContent>
          //       80
          //       <span>Load(%)</span>
          //     </S.EquipCardContent>
          //   );
          // })
          <>
            {/* 장비 ON일 경우 상태값 표기 */}
            {status === true ? (
              <>
                <S.EquipCardContent>
                  {data1}
                  <span>Load(%)</span>
                </S.EquipCardContent>
                <S.EquipCardContent>
                  {data2}
                  <span>Power(kW)</span>
                </S.EquipCardContent>
                <S.EquipCardContent>
                  {data3}
                  <span>Volt(V)</span>
                </S.EquipCardContent>
                <S.EquipCardContent>
                  {data4}
                  <span>Current(A)</span>
                </S.EquipCardContent>
              </>
            ) : (
              <>
                {/* 장비 OFF일 경우 0 표기 */}
                <S.EquipCardContent>
                  {data1}
                  <span>Load(%)</span>
                </S.EquipCardContent>
                <S.EquipCardContent>
                  {data2}
                  <span>Power(kW)</span>
                </S.EquipCardContent>
                <S.EquipCardContent>
                  {data3}
                  <span>Volt(V)</span>
                </S.EquipCardContent>
                <S.EquipCardContent>
                  {data4}
                  <span>Current(A)</span>
                </S.EquipCardContent>
              </>
            )}
          </>
        )}
      </S.EquipCardContentBox>
    </S.EquipMonitoringCard>
  );
};
